import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
For information about how to make levy payments, or planning requirements for the 36 conservation areas, please refer to the{' '} <InlineLink href="https://www.msa.vic.gov.au/" text="MSA website" mdxType="InlineLink" />.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      